"use strict";

module.exports = {
  SLIP_RESISTANT: 'SLIP_RESISTANT',
  RUA: 'RUA',
  BUA: 'BUA',
  CHEM: 'CHEM'
};